import { Typography } from '@mui/material';
import styled from 'styled-components';

export const OptionInstructions = styled(Typography)`
  font-size: 0.875rem;
  margin-bottom: 1.5em;
  margin-top: 1em;
`;
